import styled from "styled-components";

export const DismissButton = styled.button`
  border: none;
  background-color: white;
`;
